import React from "react";

export default function Product() {
  return (
    <div>
      <span>Hi </span>
    </div>
  );
}
